export const photos = [
    {
      src: require("../images/photos/aquarelle.svg"),
      width: 1,
      height: 1,
      title: "First work"
    },
    {
      src: require("../images/photos/aquarelle1.svg"),
      width: 1,
      height: 1 
    },
    {
      src: require("../images/photos/balet1.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/ballet.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/dchero.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch1.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch2.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch4.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch5.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch6.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch7.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/sketch8.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/ballet3.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/dclogo.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/connetcions.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/complement.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/indigo.svg"),
      width: 1,
      height: 1
    },
    {
      src: require("../images/photos/gameidea.svg"),
      width: 1,
      height: 1
    }
  ];
  